import { render, staticRenderFns } from "./Batiments.vue?vue&type=template&id=51ea1706&scoped=true"
import script from "./Batiments.vue?vue&type=script&lang=js"
export * from "./Batiments.vue?vue&type=script&lang=js"
import style0 from "./Batiments.vue?vue&type=style&index=0&id=51ea1706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea1706",
  null
  
)

export default component.exports